import React from 'react';

export const TxPageContext = React.createContext();
